import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuardService } from 'elbuild-ui-lib-core';

import { SECTION } from './@core/conf/acl';
import { AdminComponent } from './components/layout/admin';
import { EmptyComponent } from './components/layout/empty/empty.component';

// angular import
const routes: Routes = [
	{
		path: 'auth',
		component: EmptyComponent,
		children: [
			{
				path: '',
				loadChildren: () => import('./components/pages/auth/authentication-1/authentication-1.module').then((e) => e.Authentication1Module)
			},

		]
	},
	{
		path: 'login',
		redirectTo: '/auth/signin',
		pathMatch: 'full',
	},
	{
		path: 'forgot-password',
		redirectTo: '/auth/forgot-password',
		pathMatch: 'full',
	},
	{
		path: 'reset-password/:token',
		loadComponent: () => import('./components/pages/auth/authentication-1/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
	},
	{
		path: 'unauthorized',
		redirectTo: 'error/error-401',
		pathMatch: 'full'
	},
	{
		path: 'error',
		loadChildren: () => import('./components/pages/maintenance/exception.module').then((m) => m.ExceptionModule)
	},
	{
		path: '',
		component: AdminComponent,
		canActivate: [AuthenticationGuardService],
		canActivateChild: [AuthenticationGuardService],
		children: [
			{
				path: '',
				redirectTo: 'dashboard',
				pathMatch: 'full'
			},

			{
				path: 'dashboard',
				loadComponent: () => import('./components/pages/dashboard/dashboard.component').then((c) => c.DashboardComponent),
			},
			{
				path: 'profile',
				loadComponent: () => import('./components/pages/profile/profile.component').then((c) => c.ProfileComponent),
				data: {
					aclFeatures: [SECTION.ADMIN]
				}
			},
			{
				path: 'users',
				loadComponent: () => import('./components/pages/users/users.component').then((c) => c.UsersComponent),
				data: {
					aclFeatures: [SECTION.ADMIN]
				}
			},
			{
				path: 'storefronts',
				loadComponent: () => import('./components/pages/storefront/storefront-list/storefront-list.component').then((c) => c.StorefrontListComponent),
				data: {
					aclFeatures: [SECTION.ADMIN]
				}
			},
			{
				path: 'roles',
				loadComponent: () => import('./components/pages/role-features/role-features.component').then((c) => c.RoleFeaturesComponent),
				data: {
					aclFeatures: [SECTION.ADMIN_ADVANCED]
				}
			},
			{
				path: 'conf',
				loadComponent: () => import('./components/pages/conf/conf-list/conf-list.component').then((c) => c.ConfListComponent),
				data: {
					aclFeatures: [SECTION.ADMIN_ADVANCED]
				}
			},
			{
				path: 'cache',
				loadComponent: () => import('./components/pages/cache/cache.component').then((c) => c.CacheComponent),
				data: {
					aclFeatures: [SECTION.ADMIN]
				}
			},
			{
				path: 'lists',
				loadComponent: () => import('./components/pages/list/list-list.component').then((c) => c.ListListComponent),
				data: {
					aclFeatures: [SECTION.ADMIN]
				}
			},
			{
				path: 'lists/:id',
				loadComponent: () => import('./components/pages/list/list-item-list/list-item-list.component').then((c) => c.ListItemListComponent),
				data: {
					aclFeatures: [SECTION.ADMIN_ADVANCED]
				}
			},
			{
				path: 'i18n',
				loadComponent: () => import('./components/pages/i18n/i18n-list.component').then((c) => c.I18nListComponent),
				data: {
					aclFeatures: [SECTION.ADMIN]
				}
			},
			{
				path: 'slider',
				loadComponent: () => import('./components/pages/slider/slider.component').then((c) => c.SliderComponent),
				data: {
					aclFeatures: [SECTION.SLIDER]
				}
			},
			{
				path: 'product',
				loadComponent: () => import('./components/pages/product/product-list.component').then((c) => c.ProductListComponent),
				data: {
					aclFeatures: [SECTION.PRODUCTS]
				}
			},
			{
				path: 'product/view/:id',
				loadComponent: () => import('./components/pages/product/product-view/product-view.component').then((c) => c.ProductViewComponent),
				data: {
					aclFeatures: [SECTION.PRODUCTS]
				}
			},
			{
				path: 'product/edit/:id',
				loadComponent: () => import('./components/pages/product/product-edit/product-edit.component').then((c) => c.ProductEditComponent),
				data: {
					aclFeatures: [SECTION.PRODUCTS]
				}
			},
			{
				path: 'product/print/:id',
				loadComponent: () => import('./components/pages/product/product-print-barcode/product-print-barcode.component').then((c) => c.ProductPrintBarcodeComponent),
				data: {
					aclFeatures: [SECTION.PRODUCTS],
					blankPage: true
				}
			},
			{
				path: 'product/new',
				loadComponent: () => import('./components/pages/product/product-edit/product-edit.component').then((c) => c.ProductEditComponent),
				data: {
					aclFeatures: [SECTION.PRODUCTS]
				}
			},
			{
				path: 'attribute',
				loadComponent: () => import('./components/pages/attribute/attribute-list.component').then((c) => c.AttributeListComponent),
				data: {
					aclFeatures: [SECTION.ATTRIBUTES]
				}
			},
			{
				path: 'attribute/view/:id',
				loadComponent: () => import('./components/pages/attribute/attribute-view/attribute-view.component').then((c) => c.AttributeViewComponent),
				data: {
					aclFeatures: [SECTION.ATTRIBUTES]
				}
			},
			{
				path: 'attribute/edit/:id',
				loadComponent: () => import('./components/pages/attribute/attribute-edit/attribute-edit.component').then((c) => c.AttributeEditComponent),
				data: {
					aclFeatures: [SECTION.ATTRIBUTES]
				}
			},
			{
				path: 'attribute/new',
				loadComponent: () => import('./components/pages/attribute/attribute-edit/attribute-edit.component').then((c) => c.AttributeEditComponent),
				data: {
					aclFeatures: [SECTION.ATTRIBUTES]
				}
			},
			{
				path: 'attributeset',
				loadComponent: () => import('./components/pages/attributeset/attributeset-list/attributeset-list.component').then((c) => c.AttributesetListComponent),
				data: {
					aclFeatures: [SECTION.ATTRIBUTE_SET]
				}
			},
			{
				path: 'attributeset/view/:id',
				loadComponent: () => import('./components/pages/attributeset/attributeset-view/attributeset-view.component').then((c) => c.AttributesetViewComponent),
				data: {
					aclFeatures: [SECTION.ATTRIBUTE_SET]
				}
			},
			{
				path: 'attributeset/view/:setid/attribute/new',
				loadComponent: () => import('./components/pages/attributeset/attributeset-edit/attributeset-edit.component').then((c) => c.AttributesetEditComponent),
				data: {
					aclFeatures: [SECTION.ATTRIBUTE_SET]
				}
			},
			{
				path: 'attributeset/edit/:id',
				loadComponent: () => import('./components/pages/attributeset/attributeset-edit/attributeset-edit.component').then((c) => c.AttributesetEditComponent),
				data: {
					aclFeatures: [SECTION.ATTRIBUTE_SET]
				}
			},
			{
				path: 'attributeset/new',
				loadComponent: () => import('./components/pages/attributeset/attributeset-edit/attributeset-edit.component').then((c) => c.AttributesetEditComponent),
				data: {
					aclFeatures: [SECTION.ATTRIBUTE_SET]
				}
			},
			{
				path: 'attributesprops',
				loadComponent: () => import('./components/pages/attribute-props/attribute-props.component').then((c) => c.AttributePropsComponent),
				data: {
					aclFeatures: [SECTION.ATTRIBUTE_PROPS]
				}
			},
			{
				path: 'taxonomy',
				loadComponent: () => import('./components/pages/taxonomy/taxonomy-list/taxonomy-list.component').then((c) => c.TaxonomyListComponent),
				data: {
					aclFeatures: [SECTION.TAXONOMIES]
				}
			},
			{
				path: 'taxonomy/view/:id',
				loadComponent: () => import('./components/pages/taxonomy/taxonomy-view/taxonomy-view.component').then((c) => c.TaxonomyViewComponent),
				data: {
					aclFeatures: [SECTION.TAXONOMIES]
				}
			},
			{
				path: 'popup',
				loadComponent: () => import('./components/pages/popup/popup-list/popup-list.component').then((c) => c.PopupListComponent),
				data: {
					aclFeatures: [SECTION.SLIDER]
				}
			},
			{
				path: 'popup/view/:id',
				loadComponent: () => import('./components/pages/popup/popup-view/popup-view.component').then((c) => c.PopupViewComponent),
				data: {
					aclFeatures: [SECTION.SLIDER]
				}
			},
			{
				path: 'orders',
				loadComponent: () => import('./@theme/components/orders/orders-list/orders-list.component').then((c) => c.OrdersListComponent),
				data: {
					aclFeatures: [SECTION.CARTS]
				}
			},
			{
				path: 'orders/view/:id',
				loadComponent: () => import('./@theme/components/cart/cart-view/cart-view.component').then((c) => c.CartViewComponent),
				data: {
					aclFeatures: [SECTION.CARTS]
				}
			},
			{
				path: 'cart',
				redirectTo: 'orders',
				pathMatch: 'full'
			},
			{
				path: 'cart/view/:id',
				redirectTo: 'orders/view/:id'
			},
			{
				path: 'invoice',
				loadComponent: () => import('./@theme/components/invoice-list/invoice-list.component').then((c) => c.InvoiceListComponent),
				data: {
					aclFeatures: [SECTION.INVOICES]
				}
			},
			{
				path: 'carts',
				loadComponent: () => import('./@theme/components/carts/carts-list/carts-list.component').then((c) => c.CartsListComponent),
				data: {
					aclFeatures: [SECTION.CARTS]
				}
			},
			{
				path: 'carts/view/:id',
				loadComponent: () => import('./@theme/components/cartcart/cartcart-view/cartcart-view.component').then((c) => c.CartcartViewComponent),
				data: {
					aclFeatures: [SECTION.CARTS]
				}
			},
			{
				path: 'cartcart',
				redirectTo: 'carts',
				pathMatch: 'full'
			},
			{
				path: 'cartcart/view/:id',
				redirectTo: 'carts/view/:id'
			},
			{
				path: 'orderreturn',
				loadComponent: () => import('./@theme/components/orderreturn/orderreturn-list/orderreturn-list.component').then((c) => c.OrderreturnListComponent),
				data: {
					aclFeatures: [SECTION.ORDER_RETURNS]
				}
			},
			{
				path: 'orderreturn/view/:id',
				loadComponent: () => import('./@theme/components/orderreturn/orderreturn-view/orderreturn-view.component').then((c) => c.OrderreturnViewComponent),
				data: {
					aclFeatures: [SECTION.ORDER_RETURNS]
				}
			},
			{
				path: 'coupon',
				loadComponent: () => import('./@theme/components/coupon/coupon-list/coupon-list.component').then((c) => c.CouponListComponent),
				data: {
					aclFeatures: [SECTION.COUPONS]
				}
			},
			{
				path: 'coupon/view/:id',
				loadComponent: () => import('./@theme/components/coupon/coupon-view/coupon-view.component').then((c) => c.CouponViewComponent),
				data: {
					aclFeatures: [SECTION.COUPONS]
				}
			},
			{
				path: 'promorule',
				loadComponent: () => import('./@theme/components/promorule/promorule.component').then((c) => c.PromoruleComponent),
				data: {
					aclFeatures: [SECTION.PROMO_RULES]
				}
			},
			{
				path: 'customer',
				loadComponent: () => import('./@theme/components/customer/customer-list/customer-list.component').then((c) => c.CustomerListComponent),
				data: {
					aclFeatures: [SECTION.CUSTOMER]
				}
			},
			{
				path: 'customer/view/:id',
				loadComponent: () => import('./@theme/components/customer/customer-view/customer-view.component').then((c) => c.CustomerViewComponent),
				data: {
					aclFeatures: [SECTION.CUSTOMER]
				}
			},
			{
				path: 'customer/:id/pricelist/:pid',
				loadComponent: () => import('./@theme/components/customer/customer-view/customer-pricelist/customer-pricelistitem/customer-pricelistitem-list/customer-pricelistitem-list.component').then((c) => c.CustomerPricelistitemListComponent),
				data: {
					aclFeatures: [SECTION.CUSTOMER]
				}
			},
			{
				path: 'customergroups',
				loadComponent: () => import('./components/pages/customer-groups/customer-groups-list/customer-groups-list.component').then((c) => c.CustomerGroupsListComponent),
				data: {
					aclFeatures: [SECTION.CUSTOMER_GROUPS]
				}
			},
			{
				path: 'customergroups/view/:id',
				loadComponent: () => import('./components/pages/customer-groups/customer-groups-view/customer-groups-view.component').then((c) => c.CustomerGroupsViewComponent),
				data: {
					aclFeatures: [SECTION.CUSTOMER_GROUPS]
				}
			},
			{
				path: 'newsletter',
				loadComponent: () => import('./@theme/components/newsletter/newsletter.component').then((c) => c.NewsletterComponent),
				data: {
					aclFeatures: [SECTION.NEWSLETTER]
				}
			},
			{
				path: 'request',
				loadComponent: () => import('./@theme/components/request/request.component').then((c) => c.RequestComponent),
				data: {
					aclFeatures: [SECTION.REQUESTS]
				}
			},
			{
				path: 'request/view/:id',
				loadComponent: () => import('./@theme/components/request/request-view/request-view.component').then((c) => c.RequestViewComponent),
				data: {
					aclFeatures: [SECTION.REQUESTS]
				}
			},
			{
				path: 'influencer',
				loadComponent: () => import('./@theme/components/influencer/influencer-list/influencer-list.component').then((c) => c.InfluencerListComponent),
				data: {
					aclFeatures: [SECTION.INFLUENCERS]
				}
			},
			{
				path: 'influencer/view/:id',
				loadComponent: () => import('./@theme/components/influencer/influencer-view/influencer-view.component').then((c) => c.InfluencerViewComponent),
				data: {
					aclFeatures: [SECTION.INFLUENCERS]
				}
			},
			{
				path: 'vendor',
				loadComponent: () => import('./@theme/components/vendor/vendor-list/vendor-list.component').then((c) => c.VendorListComponent),
				data: {
					aclFeatures: [SECTION.VENDORS]
				}
			},
			{
				path: 'lowstock',
				loadComponent: () => import('./@theme/components/lowstock/lowstock-list/lowstock-list.component').then((c) => c.LowstockListComponent),
				data: {
					aclFeatures: [SECTION.LOWSTOCK]
				}
			},
			{
				path: 'purchaseorder',
				loadComponent: () => import('./@theme/components/purchase-order/purchase-order-list/purchase-order-list.component').then((c) => c.PurchaseOrderListComponent),
				data: {
					aclFeatures: [SECTION.PURCHASE_ORDERS]
				}
			},
			{
				path: 'seo',
				loadComponent: () => import('./@theme/components/seo/seo-list/seo-list.component').then((c) => c.SeoListComponent),
				data: {
					aclFeatures: [SECTION.SEO]
				}
			},
			{
				path: 'seo/view/:id',
				loadComponent: () => import('./@theme/components/seo/seo-view/seo-view.component').then((c) => c.SeoViewComponent),
				data: {
					aclFeatures: [SECTION.SEO]
				}
			},
			{
				path: 'cms',
				loadComponent: () => import('./@theme/components/cms/cms-list/cms-list.component').then((c) => c.CmsListComponent),
				data: {
					aclFeatures: [SECTION.CMS]
				}
			},
			{
				path: 'cms/view/:id',
				loadComponent: () => import('./@theme/components/cms/cms-view/cms-view.component').then((c) => c.CmsViewComponent),
				data: {
					aclFeatures: [SECTION.CMS]
				}
			},
			{
				path: 'webarticle',
				loadComponent: () => import('./@theme/components/webarticle/webarticle-list/webarticle-list.component').then((c) => c.WebarticleListComponent),
				data: {
					aclFeatures: [SECTION.WEB_ARTICLES]
				}
			},
			{
				path: 'webarticle/view/:id',
				loadComponent: () => import('./@theme/components/webarticle/webarticle-view/webarticle-view.component').then((c) => c.WebarticleViewComponent),
				data: {
					aclFeatures: [SECTION.WEB_ARTICLES]
				}
			},
			{
				path: 'language',
				loadComponent: () => import('./@theme/components/language/language-list/language-list.component').then((c) => c.LanguageListComponent),
				data: {
					aclFeatures: [SECTION.I18N]
				}
			},
			{
				path: 'shipmentexception',
				loadComponent: () => import('./@theme/components/shipmentexception/shipmentexception.component').then((c) => c.ShipmentexceptionComponent),
				data: {
					aclFeatures: [SECTION.ZONES]
				}
			},
			{
				path: 'shipmentclass',
				loadComponent: () => import('./@theme/components/shipment-class/shipment-class-list.component').then((c) => c.ShipmentClassListComponent),
				data: {
					aclFeatures: [SECTION.ZONES]
				}
			},
			{
				path: 'shipmentthreshold',
				loadComponent: () => import('./@theme/components/shipment-threshold/shipment-threshold-list/shipment-threshold-list.component').then((c) => c.ShipmentThresholdListComponent),
				data: {
					aclFeatures: [SECTION.ZONES]
				}
			},
			{
				path: 'country',
				loadComponent: () => import('./@theme/components/country/country-list/country-list.component').then((c) => c.CountryListComponent),
				data: {
					aclFeatures: [SECTION.ZONES]
				}
			},
			{
				path: 'province',
				loadComponent: () => import('./@theme/components/province/province-list/province-list.component').then((c) => c.ProvinceListComponent),
				data: {
					aclFeatures: [SECTION.ZONES]
				}
			},
			{
				path: 'city',
				loadComponent: () => import('./@theme/components/city/city-list/city-list.component').then((c) => c.CityListComponent),
				data: {
					aclFeatures: [SECTION.ZONES]
				}
			},
			{
				path: 'vat',
				loadComponent: () => import('./@theme/components/vat/vat-list/vat-list.component').then((c) => c.VatListComponent),
				data: {
					aclFeatures: [SECTION.SETTINGS]
				}
			},
			{
				path: 'vatregion',
				loadComponent: () => import('./@theme/components/vatregion/vatregion-list/vatregion-list.component').then((c) => c.VatregionListComponent),
				data: {
					aclFeatures: [SECTION.SETTINGS]
				}
			},
			{
				path: 'extbackgroundtask',
				loadComponent: () => import('./@theme/components/extbackgroundtask/extbackgroundtask-list/extbackgroundtask-list.component').then((c) => c.ExtbackgroundtaskListComponent),
				data: {
					aclFeatures: [SECTION.ADVANCED_SETTINGS]
				}
			},
			{
				path: 'taglibrary',
				loadComponent: () => import('./components/pages/taglibrary-list/taglibrary-list.component').then((c) => c.TaglibraryListComponent),
				data: {
					aclFeatures: [SECTION.ADVANCED_SETTINGS]
				}
			},
			{
				path: 'taglibrary/view/:id',
				loadComponent: () => import('./components/pages/taglibrary-list/taglibrary-view/taglibrary-view.component').then((c) => c.TaglibraryViewComponent),
				data: {
					aclFeatures: [SECTION.ADVANCED_SETTINGS]
				}
			},
			{
				path: 'taglibrary/edit/:id',
				loadComponent: () => import('./components/pages/taglibrary-list/taglibrary-edit/taglibrary-edit.component').then((c) => c.TaglibraryEditComponent),
				data: {
					aclFeatures: [SECTION.ADVANCED_SETTINGS]
				}
			},
			{
				path: 'taglibrary/new',
				loadComponent: () => import('./components/pages/taglibrary-list/taglibrary-edit/taglibrary-edit.component').then((c) => c.TaglibraryEditComponent),
				data: {
					aclFeatures: [SECTION.ADVANCED_SETTINGS]
				}
			},
			{
				path: 'firmware',
				loadComponent: () => import('./components/pages/firmware-list/firmware-list.component').then((c) => c.FirmwareListComponent),
				data: {
					aclFeatures: [SECTION.ADVANCED_SETTINGS]
				}
			},
			{
				path: 'firmware/view/:id',
				loadComponent: () => import('./components/pages/firmware-list/firmware-view/firmware-view.component').then((c) => c.FirmwareViewComponent),
				data: {
					aclFeatures: [SECTION.ADVANCED_SETTINGS]
				}
			},
			{
				path: 'firmware/edit/:id',
				loadComponent: () => import('./components/pages/firmware-list/firmware-edit/firmware-edit.component').then((c) => c.FirmwareEditComponent),
				data: {
					aclFeatures: [SECTION.ADVANCED_SETTINGS]
				}
			},
			{
				path: 'firmware/new',
				loadComponent: () => import('./components/pages/firmware-list/firmware-edit/firmware-edit.component').then((c) => c.FirmwareEditComponent),
				data: {
					aclFeatures: [SECTION.ADVANCED_SETTINGS]
				}
			},


		]
	},


	{
		path: '**',
		loadComponent: () => import('./components/pages/maintenance/error/error.component').then((c) => c.ErrorComponent)
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
